import { render, staticRenderFns } from "./StatisticsCornersGoals.vue?vue&type=template&id=1c615439&scoped=true&"
import script from "./StatisticsCornersGoals.vue?vue&type=script&lang=js&"
export * from "./StatisticsCornersGoals.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCornersGoals.vue?vue&type=style&index=0&id=1c615439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c615439",
  null
  
)

export default component.exports